import _extends from "@babel/runtime/helpers/esm/extends";
import { internalDateLocale } from "../../../../../lib/date/localeSets";
import { LangCodes } from "../../../../../lib/locale";
export var componentsLocales = _extends({
  today: 'Сегодня',
  months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
}, internalDateLocale[LangCodes.ru_RU]);